import React, { ReactNode } from 'react'
import Layout from 'antd/lib/layout'
import { useWindowSize } from 'hooks'
import { useDispatch, useSelector } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
import isNil from 'lodash/isNil'
import { history } from '@components/App'
import { BREAKPOINTS, STATUS } from '@features/General'
import { AppDispatch, RootState } from '@app-store/store'
import Header from '@components/Layouts/Header'
import ControllerFooter from '@components/ControllerFooter'
import routes from '@utils/constants/routes'
import MobileNavigation from '@components/Navigation/MobileNavigation'
import styles from './index.scss'
import { rootActions } from '@app-store/slices'

interface ICRMIntegrationLayout {
    title: string
    children: ReactNode
    subTitle?: ReactNode
    widthPage?: string
}

type LocationStateType = {
    from?: string
}

function CRMIntegrationLayout(props: ICRMIntegrationLayout) {
    const { children, title, widthPage = '100%', subTitle = null } = props
    const locationState: LocationStateType = history.location?.state
    const integrationFromPath = localStorage.getItem('integrationFromPath')

    const { width } = useWindowSize()
    const state = useSelector((state: RootState) => state)
    const { data: i18n } = useSelector((state: RootState) => state.localization.locals)
    const dispatch = useDispatch()

    React.useEffect(() => {
        if (
            history.location.pathname === routes.crm.confirmation._ &&
            isEmpty(state.ui.crmIntegration.selectedService)
        ) {
            history.goBack()
        }
    }, [])

    return (
        <>
            {/* --- mobile sidebar navigation  --- */}
            {width <= BREAKPOINTS.MD ? <MobileNavigation /> : null}
            <Layout className={styles['step-layout']}>
                {/* --- header  --- */}
                <Header layoutMode="step-layout" />
                {/* --- content  --- */}
                <Layout.Content className={styles['step-layout__content']} style={{ width: widthPage }}>
                    <div className={styles['step-layout__title']}>
                        <h1>{title}</h1>
                        <div>{!isNil(subTitle) ? subTitle : null}</div>
                    </div>
                    {children}
                </Layout.Content>
                {/* --- footer  --- */}
                <ControllerFooter
                    leaveAction={() => {
                        history.push(locationState?.from)
                    }}
                    keyRoute={routes.crm._}
                    steps={makeSteps(state, dispatch, integrationFromPath, i18n)}
                />
            </Layout>
        </>
    )
}

const makeSteps = (state: RootState, dispatch: AppDispatch, integrationFromPath, i18n) => {
    const service = state.ui.crmIntegration.selectedService

    const onConnect = () => {
        dispatch(
            rootActions.crm.authUrl.onRequest({
                typeName: service?.typeName,
                sagaCB: {
                    onSuccess(url) {
                        // let url = data
                        // if (process.env.NODE_ENV === 'development') {
                        //     url = url.replace('web.aladdinb2b.com', 'http://localhost:7080')
                        // }
                        window.open(url, '', `toolbar=no, menubar=no, width=600, height=700, top=100, left=100`)
                    },
                    onError() {
                        history.goBack()
                    }
                }
            })
        )
    }

    return [
        {
            key: 'confirmation',
            routes: [
                {
                    route: 'confirmation',
                    skip: false,
                    back: false,
                    next: {
                        disabled: false,
                        isFetching:
                            state.crm.connect.status === STATUS.RUNNING || state.crm.authUrl.status === STATUS.RUNNING,
                        onClick: () => onConnect()
                    }
                }
            ],
            stepText: i18n?.General?.Next
        },
        {
            key: 'complete',
            routes: [
                {
                    route: 'complete',
                    skip: false,
                    back: false,
                    next: {
                        text: i18n?.Settings?.Finish,
                        onClick: () => {
                            history.push(integrationFromPath || '/')
                            localStorage.removeItem('integrationFromPath')
                        }
                    }
                }
            ],
            stepText: i18n?.Settings?.Finish
        }
    ]
}

export default React.memo(CRMIntegrationLayout)
